@let articles = $articles | async;
@let section = inspirationSection();

<!-- Only show section if we have items to show. -->
@if (section.items.length || articles?.length) {
  <div *transloco="let t">
    <cft-content-section [sectionId]="section.id" [plot]="section.plot" [title]="section.title" titleAlignment="left">
      <div class="grid-4-cols-teaser-cards">
        @if (section.items.length) {
          @for (item of section.items; track item) {
            <cft-call-to-action [callToAction]="item.callToAction" callToActionStyle="content">
              <cft-teaser-card [attr.id]="identifier(item) + '-card'" [image]="item.background">
                @if (item.chip) {
                  <cft-chip [colour]="item.chip.colour">{{ item.chip.text }}</cft-chip>
                }
                <cft-teaser-card-title>{{ item.title }}</cft-teaser-card-title>
                <div>{{ item.description }}</div>
              </cft-teaser-card>
            </cft-call-to-action>
          }
        } @else if (articles && articles.length) {
          @for (article of articles; track article.slug) {
            <a [routerLink]="article.path">
              <cft-teaser-card [attr.id]="article.slug + '-card'" [image]="article.headerImage">
                <cft-teaser-card-title>{{ article.title }}</cft-teaser-card-title>
              </cft-teaser-card>
            </a>
          }
        }
      </div>
      @if (section.callToAction) {
        <cft-call-to-action class="pt-xl" [callToAction]="section.callToAction" />
      }
    </cft-content-section>
  </div>
}
